var Heros = {
    init: function(target) {
        $slider = $(target);
        $slider.slick({
            lazyLoad: 'ondemand',
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            infinite: true,
            speed: 500,
            fade: true,
            cssEase: 'linear'
        });

        $(target+' .scroll-down').click(function(e){
          $("html, body").animate({ scrollTop: $(target).innerHeight() }, 500); 
          e.preventDefault();
        });
    
    }
}